import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsOnboardingHubEditRoute: InvariantJiraRoute = {
	name: 'products-onboarding-hub-edit',
	path: '/jira/settings/products/onboarding/:id/edit',
};
